import { Injectable } from '@angular/core';
import { BaseParamsService } from '../base-params.service';
import { SettingsService } from '@app/core/settings/settings.service';
import * as deeplink from '../../shared/utils/browser-deeplink';
import { Settings } from '@app/core/_models/settings';
import { first } from 'rxjs/operators';
import { CanActivate, CanActivateChild } from '@angular/router';

@Injectable()
export class OpenMobileStoreGuard implements CanActivate, CanActivateChild {
  constructor(private settingsService: SettingsService, private baseParamsService: BaseParamsService) { }

  public canActivate(): boolean {
    this.openStoreLinkWhenApplicable();
    return true;
  }

  public canActivateChild(): boolean {
    return this.canActivate();
  }

  private openStoreLinkWhenApplicable(): void {
    this.settingsService.getSettingsOnce().pipe(
      first(),
    ).subscribe((settings) => {
      if (settings.mobile_app_setting?.universal_links_enabled && this.shouldOpenStoreWhenMobile(settings)) {
        deeplink.openStoreLink();
      }
    });
  }

  private shouldOpenStoreWhenMobile(settings: Settings): boolean {
    return this.baseParamsService.forceOpenStoreWhenMobile == null && !!settings.open_store_when_mobile
      || !!this.baseParamsService.forceOpenStoreWhenMobile;
  }
}
